export enum CardType {
    Red = "red",
    Yellow = "yellow",
}
